import './relatorio.css'
import GaugeComponent from "react-gauge-component";
import { useEffect, useState } from 'react';
import Icon from '@mdi/react';
import { mdiBus, mdiHomeFlood, mdiMapMarkerRadius, mdiNewspaperVariantMultipleOutline, mdiOfficeBuilding, mdiSecurity } from '@mdi/js';

export default function Indicadores({ dadosIndicadores, cidade }) {

  const [indSeguranca, setIndSeguranca] = useState(0);
  const [indSegurancaNota, setIndSegurancaNota] = useState(0);
  const [indInfra, setIndInfra] = useState(0);
  const [indTransporte, setIndTransporte] = useState(0);
  const [indClima, setIndClima] = useState(0);

  const [indSegurancaTexto, setIndSegurancaTexto] = useState('');
  const [indInfraTexto, setIndInfraTexto] = useState('');
  const [indTransporteTexto, setIndTransporteTexto] = useState('');
  const [indClimaTexto, setIndClimaTexto] = useState('');

  function calcularNotaSeguranca(qtdCrimes) {
    const crimes = Number(qtdCrimes) || 0;

    const limiteMuitoRuim = 1200;

    let nota = 10 - (
      Math.log10(crimes + 1) / Math.log10(limiteMuitoRuim + 1)
    ) * 10;

    nota = Math.max(0, Math.min(10, nota));
    nota = Number(nota.toFixed(1));

    let texto;

    if (nota >= 9.5) {
      texto = 'Excelente';
    } else if (nota >= 8.5) {
      texto = 'Ótima';
    } else if (nota >= 7.5) {
      texto = 'Boa';
    } else if (nota >= 6) {
      texto = 'Regular';
    } else if (nota >= 2) {
      texto = 'Ruim';
    } else {
      texto = 'Péssima';
    }

    return { nota, texto };
  }

  function calcularNotaTransporte(dadosIndicadores) {
    const pOnibusTotal = Number(dadosIndicadores.pontos_onibus) || 0;
    const eMetroTotal = Number(dadosIndicadores.estacoes_metro) || 0;
    const tOnibus = Number(dadosIndicadores.terminais_onibus) || 0;
    const tTrem = Number(dadosIndicadores.estacoes_trem) || 0;

    let nota = 0;

    //Fora do centro expandido
    if (cidade.toLowerCase() !== "são paulo" && cidade.toLowerCase() !== "sao paulo"){
      //Ponto de ônibus considera que tem
      nota += 3.0;
      //Metrô com peso ok
      if (eMetroTotal > 0) nota += 3.0;
      //Terminal de ônibus com menor peso
      if (tOnibus > 0) nota += 0.5;
      //Trem com maior peso
      if (tTrem > 0) nota += 3.5;
    }

    //Capital
    if (cidade.toLowerCase() === "são paulo" || cidade.toLowerCase() === "sao paulo"){
      if (pOnibusTotal > 0) nota += 5.0;
      if (eMetroTotal > 0) nota += 3.0;
      if (tOnibus > 0) nota += 1.5;
      if (tTrem > 0) nota += 0.5;
    }

    

    nota = Number(nota.toFixed(1));

    let texto = '';

    if (nota >= 9) {
      texto = 'Excelente';
    } else if (nota >= 7.5) {
      texto = 'Ótima';
    } else if (nota >= 6) {
      texto = 'Boa';
    } else if (nota >= 4) {
      texto = 'Regular';
    } else if (nota >= 2) {
      texto = 'Ruim';
    } else {
      texto = 'Péssima';
    }

    return { nota, texto };
  }


  function calcularNotaInfraestrutura(dadosIndicadores) {

    const restaurantes = Number(dadosIndicadores.restaurantes) || 0;
    const supermercados = Number(dadosIndicadores.supermercados) || 0;
    const hospitais = Number(dadosIndicadores.hospitais) || 0;
    const farmacias = Number(dadosIndicadores.farmacias) || 0;

    let nota = 0;

    // HOSPITAIS (peso maior)
    nota += Math.min(hospitais, 5) * 0.8;
    nota += Math.min(supermercados, 5) * 0.5;
    nota += Math.min(farmacias, 5) * 0.4;
    nota += Math.min(restaurantes, 5) * 0.3;

    nota = Math.min(nota, 10);
    nota = Number(nota.toFixed(1));

    let texto = '';

    if (nota >= 9) {
      texto = 'Excelente';
    } else if (nota >= 7.5) {
      texto = 'Ótima';
    } else if (nota >= 6) {
      texto = 'Boa';
    } else if (nota >= 4) {
      texto = 'Regular';
    } else if (nota >= 2) {
      texto = 'Ruim';
    } else {
      texto = 'Péssima';
    }

    return { nota, texto };
  }

  function calcularNotaDesastres(dadosIndicadores) {
    const qtd = Number(dadosIndicadores?.desastres_ambientais) || 0;

    let nota = 10;
    if (qtd === 1) nota = 6.0;
    else if (qtd === 2) nota = 4.0;
    else if (qtd >= 4) nota = 2.0;
    else if (qtd >= 6) nota = 0;

    nota = Number(nota.toFixed(1));

    let texto = '';

    if (nota >= 9) {
      texto = 'Excelente';
    } else if (nota >= 7.5) {
      texto = 'Ótima';
    } else if (nota >= 6) {
      texto = 'Boa';
    } else if (nota >= 4) {
      texto = 'Regular';
    } else if (nota >= 2) {
      texto = 'Ruim';
    } else {
      texto = 'Péssima';
    }

    return { nota, texto };
  }



  const seguranca = calcularNotaSeguranca(
    dadosIndicadores?.seguranca_publica || 0
  );

  const transporte = calcularNotaTransporte(
    dadosIndicadores || 0
  )

  const infraestrutura = calcularNotaInfraestrutura(
    dadosIndicadores || 0
  )

  const desastres = calcularNotaDesastres(
    dadosIndicadores || 0
  )

  const notaGeral = (seguranca.nota + transporte.nota + infraestrutura.nota + desastres.nota) / 4;
  const getCorNota = (nota) => {
    if (nota < 5) return '#db1714'; // Ruim / Péssimo
    if (nota < 7.5) return '#fc7b44'; // Regular / Médio
    return '#55b758'; // Bom / Excelente
  };

  const getTextoNota = (nota) => {
    if (nota >= 9) return 'Excelente';
    if (nota >= 8) return 'Ótima';
    if (nota >= 6) return 'Boa';
    if (nota >= 4) return 'Regular';
    if (nota >= 2) return 'Ruim';
    return 'Péssima';
  };

  const circumference = 2 * Math.PI * 50; // ~314.16
  const strokeDashoffset = circumference - (notaGeral / 10) * circumference;
  const corNota = getCorNota(notaGeral);

  useEffect(() => {
    // Caso queira adicionar efeitos com base nas notas
  }, [dadosIndicadores])


  return (
    <section className='relatorio_avaliacao_geral' style={{ marginBottom: 20 }}>
      <div className='relatorio_secao_titulo'>
        <h1>Análise geral da localidade</h1>
        <p>Indicadores consolidados que sintetizam os principais fatores de risco e infraestrutura da região.</p>
      </div>

      <div className='block-stats'>

        <div className='visao-geral'>

          <div className='visao-geral_block'>
            <div className='circular-chart-container'>
              <svg className="circular-chart" viewBox="0 0 120 120" width="160" height="160">
                <circle
                  cx="60"
                  cy="60"
                  r="50"
                  fill="none"
                  stroke="#e2e8f0"
                  strokeWidth="8"
                />
                <circle
                  cx="60"
                  cy="60"
                  r="50"
                  fill="none"
                  stroke={corNota}
                  strokeWidth="8"
                  strokeDasharray={circumference}
                  strokeDashoffset={strokeDashoffset}
                  strokeLinecap="round"
                  transform="rotate(-90 60 60)"
                  style={{ transition: 'stroke-dashoffset 0.5s ease-in-out' }}
                />
              </svg>
              <div className='circular-chart-content'>
                <h1 style={{ color: corNota }}>{notaGeral.toFixed(1)}</h1>
              </div>
            </div>
            <div className='visao-geral_info'>
              <h2 style={{ color: corNota }}>{getTextoNota(notaGeral)}</h2>
              <p>Nota geral</p>
            </div>
          </div>
        </div>
        <div className='indicadores'>
          <div className='group-indicadores'>
            <div className='indicador' style={{ backgroundColor: getCorNota(seguranca.nota) + '11' }}>
              <Icon path={mdiSecurity} size={2} color={getCorNota(seguranca.nota)} />
              <h2>Segurança</h2>
              <h1 style={{ color: getCorNota(seguranca.nota) }}>{seguranca.nota}</h1>
              <p style={{ backgroundColor: getCorNota(seguranca.nota) }}>{seguranca.texto}</p>
            </div>
            <div className='indicador' style={{ backgroundColor: getCorNota(transporte.nota) + '11' }}>
              <Icon path={mdiBus} size={2} color={getCorNota(transporte.nota)} />
              <h2>Transportes</h2>
              <h1 style={{ color: getCorNota(transporte.nota) }}>{transporte.nota}</h1>
              <p style={{ backgroundColor: getCorNota(transporte.nota) }}>{transporte.texto}</p>
            </div>
            <div className='indicador' style={{ backgroundColor: getCorNota(infraestrutura.nota) + '11' }}>
              <Icon path={mdiOfficeBuilding} size={2} color={getCorNota(infraestrutura.nota)} />
              <h2>Infraestrutura</h2>
              <h1 style={{ color: getCorNota(infraestrutura.nota) }}>{infraestrutura.nota}</h1>
              <p style={{ backgroundColor: getCorNota(infraestrutura.nota) }}>{infraestrutura.texto}</p>
            </div>
            <div className='indicador' style={{ backgroundColor: getCorNota(desastres.nota) + '11' }}>
              <Icon path={mdiHomeFlood} size={2} color={getCorNota(desastres.nota)} />
              <h2>Riscos ambientais</h2>
              <h1 style={{ color: getCorNota(desastres.nota) }}>{desastres.nota}</h1>
              <p style={{ backgroundColor: getCorNota(desastres.nota) }}>{desastres.texto}</p>
            </div>
          </div>
        </div>

      </div>

    </section>
  )
}